import StackableStepsView from './StackableSteps.view';
import { StackableStep } from './StackableSteps.props';

export type { StackableStep };
export default StackableStepsView;
